<template>
  <div>
    <!-- <span v-if="statistical < 30">
      <i class="iconfont icon-remen color-3"></i>
    </span>
    <span v-if="statistical >= 30 && statistical < 90">
      <i class="iconfont icon-remen color-3"></i>
      <i class="iconfont icon-remen color-3"></i>
    </span>
    <span v-if="statistical >= 90 && statistical < 270">
      <i class="iconfont icon-remen color-3"></i>
      <i class="iconfont icon-remen color-3"></i>
      <i class="iconfont icon-remen color-3"></i>
    </span>
    <span v-if="statistical >= 270 && statistical < 810">
      <i class="iconfont icon-remen color-2"></i>
    </span>
    <span v-if="statistical >= 810 && statistical < 2430">
      <i class="iconfont icon-remen color-2"></i>
      <i class="iconfont icon-remen color-2"></i>
    </span>
    <span v-if="statistical >= 2430 && statistical < 7290">
      <i class="iconfont icon-remen color-2"></i>
      <i class="iconfont icon-remen color-2"></i>
      <i class="iconfont icon-remen color-2"></i>
    </span> -->
    <span v-if="statistical < 100">
      <i class="iconfont icon-remen color-1"></i>
    </span>
    <span v-if="statistical >= 100 && statistical < 1000">
      <i class="iconfont icon-remen color-1"></i>
      <i class="iconfont icon-remen color-1"></i>
    </span>
    <span v-if="statistical >= 1000">
      <i class="iconfont icon-remen color-1"></i>
      <i class="iconfont icon-remen color-1"></i>
      <i class="iconfont icon-remen color-1"></i>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    statistical: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style scoped>
.color-1 {
  color: red;
}

.color-2 {
  color: #ff6941;
}

.color-3 {
  color: #ff9001;
}
</style>